import EditIcon from '@/shared/assets/icons/edit.svg?react'
import { BaseButton } from '@/shared/components'
import { FarmIcon } from '@/shared/components/icons/FarmIcon'
import { FarmWorkIndicators } from '@/entities/farm'
import { AdminRequisitFarmListPayload } from 'syncra-api-client'

interface FarmHeaderProps {
  data: AdminRequisitFarmListPayload
  openModal: () => void
}

export const FarmHeader = ({ data, openModal }: FarmHeaderProps) => {
  const getFarmStatus = () => {
    if (data.farm?.isBlocked || data.farm?.isDisabledByUser) return 'stopped'
    if (data.farm?.isDeleted) return 'canceled'
    return 'active'
  }

  return (
    <div className="flex flex-col justify-between items-start gap-2 w-full pb-6 border-b border-b-card-border dark:border-b-card-border-dark">
      <div className="flex flex-row gap-4 justify-between w-full">
        <FarmIcon
          status={getFarmStatus()}
          className="w-[52px] md:w-[40px] h-[52px] md:h-[40px] shrink-0 ml-[-10px]"
        />
        <span className="text-[20px] leading-[40px]">{data.farm!.name}</span>
        <BaseButton
          variant="ghost"
          padding="none"
          radius="md"
          className="py-3 ring-card-border dark:ring-card-border-dark text-primary dark:text-primary-dark"
          onClick={(e) => {
            e.preventDefault()
            openModal()
          }}
        >
          <div title="Настроить">
            <EditIcon className="text-text-secondary md:dark:text-primary-dark md:text-primary" />
          </div>
        </BaseButton>
      </div>
      <FarmWorkIndicators data={data} />
    </div>
  )
}
